import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { QuoteSessionQuery } from '@app/store/session/session.query';
import { ROUTES } from '@constants/routes';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class NotPurchasedGuard  {
	constructor(
		private readonly session: QuoteSessionQuery,
		private readonly router: Router,
	) { }

	public canLoad(
		route: Route,
		segments: UrlSegment[],
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.session.quoteDetailsState$()
			.pipe(take(1))
			.toPromise()
			.then(quoteDetails => {
				if (quoteDetails?.purchaseSucceeded) {
					return true;
				}

				return this.router.parseUrl(ROUTES.PET_INFORMATION);
			});
	}

}
